import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';

const InputGroupSelectChild = ({ value, handleChange, disabled, field }) => {
  return (
    <FormControl
      as={field.type}
      className="input-group-addon-custom form-custom"
      value={value}
      onChange={(e) => {handleChange(e.target.value)}}
      disabled={disabled}
    >
      {
        field?.option?.map((f) => (
          <option key={f.value} value={f.value}>
            {f.label}
          </option>
        ))
      }
    </FormControl>
  );
};

InputGroupSelectChild.propTypes = {
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  field: PropTypes.object.isRequired,
};

export default InputGroupSelectChild;
